import { useTranslation } from 'react-i18next';
import { StyledDialog } from '@/components/consent/StyledDialog';
import { SemiBold, SMBold, SMRegular } from '@/typography/Typography';
import { useTheme } from '@emotion/react';
import { useUser } from '@/contexts/user/UserContext';
import { DialogActions } from '@mui/material';
import {
    DangerButton,
    OutlinedSecondaryButton,
    PrimaryButton
} from '@/components/shared/Button';
import React from 'react';

export interface ConfirmationOverlayProps {
    open: boolean;
    onCancel: () => void;
    onContinue: () => void;
    p1?: React.ReactNode;
    p2?: React.ReactNode;
    loading?: boolean;
    danger?: boolean;
    displayAreYouSureText?: boolean;
    continueText?: string;
}

export const ConfirmationOverlay = ({
    open,
    onCancel,
    onContinue,
    p1,
    p2,
    loading,
    danger,
    displayAreYouSureText = true,
    continueText
}: ConfirmationOverlayProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <StyledDialog
            open={open}
            PaperProps={{
                style: {
                    borderRadius: '12px'
                }
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    width: '400px',
                    padding: '24px'
                }}
            >
                <div className="col align-center">
                    {displayAreYouSureText && (
                        <SMBold m={0.5} fontSize={'14px'}>
                            Are you sure?
                        </SMBold>
                    )}
                    {p1 ?? (
                        <p className="text-center">
                            <SMRegular color={theme.palette.text.disabled}>
                                not set
                            </SMRegular>
                        </p>
                    )}
                    {p2 ?? (
                        <p className="text-center">
                            <SemiBold className="inline">not set</SemiBold>
                        </p>
                    )}
                </div>

                <DialogActions
                    sx={{
                        justifyContent: 'center',
                        gap: 1,
                        paddingX: 0,
                        paddingTop: '12px'
                    }}
                >
                    <OutlinedSecondaryButton
                        fullWidth
                        color="secondary"
                        style={{
                            height: '44px',
                            borderRadius: '8px'
                        }}
                        onClick={onCancel}
                    >
                        <SMBold textTransform={'none'}>{t('Cancel')}</SMBold>
                    </OutlinedSecondaryButton>

                    {!danger && (
                        <PrimaryButton
                            fullWidth
                            size="large"
                            style={{ height: '44px' }}
                            onClick={onContinue}
                            loading={loading}
                            id={'continue-confirm'}
                        >
                            {!loading ? (continueText ?? 'Continue') : null}
                        </PrimaryButton>
                    )}

                    {danger && (
                        <DangerButton
                            fullWidth
                            size="large"
                            style={{ height: '44px' }}
                            onClick={onContinue}
                            loading={loading}
                            id={'continue-confirm'}
                        >
                            {!loading ? (continueText ?? 'Continue') : null}
                        </DangerButton>
                    )}
                </DialogActions>
            </div>
        </StyledDialog>
    );
};
